import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

export interface SocialMediaLinks {
  facebook?: string;
  instagram?: string;
  twitter?: string;
  linkedin?: string;
}

export interface ContactActionEvent {
  type: 'website' | 'phone' | 'whatsapp' | 'email' | 'share' | 'social';
  platform?: string;
  value?: string;
}

@Component({
  selector: 'app-contact-info',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './contact-info.component.html',
  styleUrl: './contact-info.component.scss'
})
export class ContactInfoComponent {
  @Input() website?: string;
  @Input() phone?: string;
  @Input() email?: string;
  @Input() showWhatsApp: boolean = false;
  @Input() showSocialMedia: boolean = false;
  @Input() socialMedia?: SocialMediaLinks;

  @Output() contactAction = new EventEmitter<ContactActionEvent>();

  onWebsite() {
    this.contactAction.emit({ type: 'website', value: this.website });
  }

  onPhone() {
    this.contactAction.emit({ type: 'phone', value: this.phone });
  }

  onWhatsApp() {
    this.contactAction.emit({ type: 'whatsapp', value: this.phone });
  }

  onEmail() {
    this.contactAction.emit({ type: 'email', value: this.email });
  }

  onShare() {
    this.contactAction.emit({ type: 'share' });
  }

  onSocialMedia(platform: string, url?: string) {
    this.contactAction.emit({ type: 'social', platform, value: url });
  }

  hasContactInfo(): boolean {
    return !!(this.website || this.phone || this.email || this.hasSocialMedia());
  }

  hasSocialMedia(): boolean {
    return !!(
      this.showSocialMedia && 
      this.socialMedia && 
      (this.socialMedia.facebook || this.socialMedia.instagram || 
       this.socialMedia.twitter || this.socialMedia.linkedin)
    );
  }
}
